// Convenient console.log() function
if (typeof window.log != 'function') {
    window.log = function() {
        log.history = log.history || [];   // store logs to an array for reference
        log.history.push(arguments);
        arguments.callee = arguments.callee.caller; 
        if (this.console) console.log(Array.prototype.slice.call(arguments));
    };
}
// make it safe to use console.log always
(function(b) {
    function c(){}
    for(var d="assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profileEnd,time,timeEnd,trace,warn".split(","),a; a=d.pop();) b[a] = b[a]||c
})(window.console=window.console||{});



function makeUrlAjaxReady(url){
	var ret="";
	var arrUrl = url.split("?");
	var qString = "";
	if( arrUrl[1] ){
		var arrQ = arrUrl[1].split("&");
		for( var i=0; i<arrQ.length; i++ ){
			var keyValue = arrQ[i].split("=");
			qString += keyValue[0]+"="+encodeURIComponent(keyValue[1])+"&";
		}
	}
	ret = arrUrl[0]+"?"+qString;
	return ret;
}

//strip px from css width/height
function getCssNum(num){
	num = parseInt(num.replace("px", ""));
	return num;
}

String.prototype.trim = function () {
    return this.replace(/^\s*/, "").replace(/\s*$/, "");
}

//truncate a string to specified length if longer
function truncate(str, len){
	if(str.length <= len)
		return str;
	else
		return str.substring(0, len) + "...";
}

//----------------------------------------
// load popup window
//----------------------------------------

var g_popupWin;
function loadPage(url,height,width,focus,scroll,close){
	if( typeof(focus) == "undefined" ){focus = false}
	if( typeof(scroll) == "undefined" ){scroll = 0}
	if( typeof(close) == "undefined" ){close = false}
	var w = 480, h = 340;
	var browserName=navigator.appName;
	if (browserName=="Netscape") {
		w = window.innerWidth;
		h = window.innerHeight;
	} else {
		if (browserName=="Microsoft Internet Explorer") {
			w = document.body.clientWidth;
			h = document.body.clientHeight;
		}
	}

	var popW = width, popH = height;
	var leftPos = (w-popW)/2, topPos = (h-popH)/2;
	
	g_popupWin = window.open(url, 'popupWin',
		'toolbars=0, '+
		'scrollbars=' + scroll + ', '+
		'location=0, status=0, menubars=0,'+
		'resizable=1, width='+width+', height='+height+
		', left='+leftPos +', top='+topPos);

	if( focus && g_popupWin ){
		g_popupWin.focus();
	}
	//detect popup block
	if(!g_popupWin){
  		alert('We have detected that you are using popup blocking software.\nPlease "allow popups from this website" and try your selection again.');
	} else if(close) {
		g_popupWin.close();
	}	
}

//-----------------------------------------------
// Extend DATE Object to support addDays function
//-----------------------------------------------
if (typeof Date.prototype.addDays != 'function') { 
    Date.prototype.addDays = function(days) { 
        var d = new Date(this.getFullYear(), this.getMonth(), this.getDate());
        d.setTime(d.getTime() + (days * 24*60*60*1000));
        return d;
    }
}

//-----------------------------------------------
// Pads a string with a specific character
//-----------------------------------------------
if (typeof String.prototype.lpad != 'function') { 
    String.prototype.lpad = function(padString, length) {
        var str = this;
        while (str.length < length)
            str = padString + str;
        return str;
    }
}
if (typeof Number.prototype.lpad != 'function') {
    Number.prototype.lpad = function(padString, length) {
        var str = '' + this;
        return str.lpad(padString, length);
    }   
}

if (typeof String.prototype.rpad != 'function') { 
    String.prototype.rpad = function(padString, length) {
        var str = this;
        while (str.length < length)
            str = str + padString;
        return str;
    }
}
if (typeof Number.prototype.rpad != 'function') {
    Number.prototype.rpad = function(padString, length) {
        var str = '' + this;
        return str.rpad(padString, length);
    }
}
